import { DestinationItem, DestinationItemType} from '@tableau/nested-project-explorer';
import * as _ from 'underscore';

import { IDestinationProject } from '../ServerApi/types/IDestinationProject';

export namespace DestinationProjectMapper {

  export function map(destinationProjects: IDestinationProject[]): DestinationItem[] {
    return _.map(destinationProjects, p => ({
      id: String(p.id),  // the api returns numbers but we want strings
      name: p.name || '',
      itemType: DestinationItemType.project,
      parentId: p.parentProjectId,
      childItemCount: p.childProjectCount,
      topLevelItem: p.topLevelProject,
      controlledPermissionsEnabled: p.controlledPermissionsEnabled,
      status: p.status
    }));
  }
}
